import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Info } from 'lucide-react';

const SOURCE_CONFIG = {
  rule_exact_merchant_cardholder: { label: 'Exact Rule', cls: 'badge-rule_exact_merchant_cardholder', short: 'Exact' },
  rule_exact_merchant_global:     { label: 'Global Rule', cls: 'badge-rule_exact_merchant_global', short: 'Global' },
  rule_keyword:                   { label: 'Keyword', cls: 'badge-rule_keyword', short: 'Keyword' },
  rule_mcc:                       { label: 'MCC', cls: 'badge-rule_mcc', short: 'MCC' },
  recurring_pattern:              { label: 'Recurring', cls: 'badge-recurring_pattern', short: 'Recurring' },
  prior_allocation:               { label: 'Prior', cls: 'badge-prior_allocation', short: 'Prior' },
  needs_review:                   { label: 'Review', cls: 'badge-needs_review', short: 'Review' },
};

export function SuggestionBadge({ suggestion }) {
  if (!suggestion) return null;
  const src = suggestion.source_type || 'needs_review';
  const cfg = SOURCE_CONFIG[src] || { label: src, cls: 'badge-needs_review', short: src };
  const conf = Math.round((suggestion.confidence || 0) * 100);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-semibold cursor-pointer ${cfg.cls}`}
          aria-haspopup="dialog"
          aria-label={`Suggestion: ${cfg.label} (${conf}% confidence)`}
        >
          {cfg.short}
          <span className="opacity-70">{conf}%</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-3 bg-white border shadow-lg" side="top">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="font-semibold text-sm">Suggestion Source</span>
            <span className={`text-[10px] font-bold px-2 py-0.5 rounded ${cfg.cls}`}>{cfg.label}</span>
          </div>
          <div className="text-xs text-slate-600 leading-relaxed">{suggestion.explanation}</div>
          <div className="flex items-center gap-2 pt-1">
            <span className="text-xs text-slate-500">Confidence:</span>
            <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full ${
                  conf >= 85 ? 'bg-emerald-500' : conf >= 65 ? 'bg-amber-500' : 'bg-orange-500'
                }`}
                style={{ width: `${conf}%` }}
              />
            </div>
            <span className="text-xs font-semibold">{conf}%</span>
          </div>
          {suggestion.category_id && (
            <div className="text-xs text-slate-500 pt-1">
              <span className="font-medium">Suggested category/CC applied</span> when confidence ≥ 85%
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
